<template>
  <el-cascader :value="value" :props="props" style="width:100%" @change="handelChange"> </el-cascader>
</template>

<script>
import { provinces, cities, areas } from "@/api/base";
export default {
  name: "Areas",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    value: {
      handler: function(val) {
        this.cusVal = this.value;
      },
      immediate: true,
      deep: true,
    },
  },
  model: {
    event: "change",
  },
  mounted() {},
  methods: {
    handelChange(value) {
      this.$emit("change", value);
      this.$emit("on-change", value);
    },
  },
  data() {
    return {
      provinceArr: [], // 省
      cityArr: [], // 市
      districtArr: [], // 区
      procidiArr: [], // 省市区级联选择id
      cusVal: [],
      props: {
        lazy: true,

        lazyLoad(node, resolve) {
          const { level } = node;
          if (level == 0) {
            provinces({}).then((res) => {
              this.provinceArr = res;
              var nodes = this.provinceArr.map((item) => {
                return {
                  value: `${item.key}-${item.value}`,
                  label: item.value,
                  leaf: false,
                };
              });
              resolve(nodes);
            });
          } else if (level == 1) {
            cities({
              provinceId: node.data.value.split("-")[0],
            }).then((res) => {
              this.cityArr = res;
              var nodes = this.cityArr.map((item) => {
                return {
                  value: `${item.key}-${item.value}`, //item.key,
                  label: item.value,
                  leaf: false,
                };
              });
              resolve(nodes);
            });
            // console.log(this.cityArr);
          } else if (level == 2) {
            areas({
              cityId: node.data.value.split("-")[0],
            }).then((res) => {
              this.districtArr = res;
              var nodes = this.districtArr.map((item) => {
                return {
                  value: `${item.key}-${item.value}`, //item.key,
                  label: item.value,
                  leaf: true,
                };
              });
              resolve(nodes);
            });
          }
        },
      },
    };
  },
};
</script>

<style></style>
